module.exports = __webpack_public_path__ + "static/img/yxgl-kq-2.eb8b771.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/yxgl-kq-2.png
// module id = cdXm
// module chunks = 0